let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fjbzp")).then(() => parcelRequire('krc3E'));